<!-- ===== 上方查詢區 ===== -->
<div class="container">
  <h1 class="page-title" >
    <span class="icon"><i class="fas fa-bullhorn"></i></span>{{ 'HelpCenter.Setting.SearchHeader' | translate }}
  </h1>
  <p-card>
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </p-card>

  <ng-template #content>
    <p-accordion>
      <p-accordionTab [selected]="true" header="{{ 'Common.Form.Header' | translate }}">
        <form [formGroup]="searchForm">
          <div class="p-fluid">
            <div class="field grid">
              <label class="col-12 mb-2 md:col-1 md:mb-0">
                <span class="requiredStart">*</span>
                {{ 'HelpCenter.Setting.SearchForm.FunctionPermission' | translate }}
              </label>
              <div class="col-12 md:col-3">
                <p-dropdown
                  formControlName="permissionCode"
                  [options]="helpCenterDropdown"
                  [showClear]="true"
                  [filter]="true"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  appendTo="body"
                  [ngClass]="{'ng-invalid ng-dirty': searchForm.get('permissionCode')?.invalid && searchForm.get('permissionCode')?.touched}">
                </p-dropdown>
                <small
                  class="p-invalid"
                  *ngIf="searchForm.get('permissionCode')?.invalid && searchForm.get('permissionCode')?.touched">
                  {{ "Common.Button.Required" | translate }}
                </small>
              </div>
            </div>
          </div>
          <div class="grid align-items-center vertical-container mt-4">
            <button
              pButton
              pRipple
              label="{{ 'Common.Button.Search' | translate }}"
              (click)="searchBtnClick()"
              class="ml-2">
            </button>
            <button
              pButton
              label="{{ 'Common.Button.Reset' | translate }}"
              class="p-button-secondary ml-2"
              (click)="resetBtnClick()">
            </button>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>
  </ng-template>

  <!-- ===== 查詢結果 ===== -->
  <div class="mt-3">

    <!-- ALL view：表格 -->
    <ng-container *ngIf="viewMode === 'ALL'">
      <laas-data-table
        #dataTable
        [loading]="isLoading"
        [defaultColumns]="tableColumns"
        [value]="tableValue"
        [tableKey]="'HeplCenter'"
        [dataKey]="'permissionCode'"
        [selectable]="false">

        <ng-template pTemplate="body" let-rowData let-cols="columns">
          <td *ngFor="let col of cols">
            <ng-container [ngSwitch]="col.field">

              <!-- 功能名稱（移除 permissionCode 顯示） -->
              <ng-container *ngSwitchCase="'guideHeader'">
                <div class="overflow-text font-semibold">
                  {{ rowData.guideHeader | replaceNullWith:'-' }}
                </div>
              </ng-container>

            <!-- User 文章狀態 -->
            <ng-container *ngSwitchCase="'userArticle'">
              <!-- 可點擊區域 -->
              <div class="cursor-pointer" (click)="openUserArticle(rowData)">
                <div class="flex align-items-center gap-2">
                  <!-- 發佈狀態標籤 -->
                  <p-tag
                    [severity]="rowData.userArticle?.hasContent && rowData.userArticle?.isPublished ? 'success' : 'warning'"
                    [value]="(rowData.userArticle?.hasContent && rowData.userArticle?.isPublished ? 'HelpCenter.Setting.Results.Published' : 'HelpCenter.Setting.Results.Unpublished') | translate"
                    [rounded]="true">
                  </p-tag>

                  <!-- 檢視連結 -->
                  <a class="article-link">
                    <span>{{ (rowData.userArticle?.hasContent && rowData.userArticle?.isPublished ? 'HelpCenter.Setting.Results.ViewContent' : 'HelpCenter.Setting.Results.ViewDraft') | translate }}</span>
                    <i class="pi pi-angle-right"></i>
                  </a>
                </div>

                <!-- 更新資訊 -->
                <div *ngIf="rowData.userArticle?.updateUser" class="text-xs text-500 mt-1">
                  {{ 'HelpCenter.Setting.Results.LastUpdate' | translate }}：{{ rowData.userArticle.updateUser }} · {{ rowData.userArticle.updateDt | date:'yyyy/MM/dd' }}
                </div>
              </div>
            </ng-container>

            <!-- IT 文章狀態 -->
            <ng-container *ngSwitchCase="'itArticle'">
              <!-- 可點擊區域 -->
              <div class="cursor-pointer" (click)="openITArticle(rowData)">
                <div class="flex align-items-center gap-2">
                  <!-- 發佈狀態標籤 -->
                  <p-tag
                    [severity]="rowData.itArticle?.hasContent && rowData.itArticle?.isPublished ? 'success' : 'warning'"
                    [value]="(rowData.itArticle?.hasContent && rowData.itArticle?.isPublished ? 'HelpCenter.Setting.Results.Published' : 'HelpCenter.Setting.Results.Unpublished') | translate"
                    [rounded]="true">
                  </p-tag>

                  <!-- 檢視連結 -->
                  <a class="article-link">
                    <span>{{ (rowData.itArticle?.hasContent && rowData.itArticle?.isPublished ? 'HelpCenter.Setting.Results.ViewContent' : 'HelpCenter.Setting.Results.ViewDraft') | translate }}</span>
                    <i class="pi pi-angle-right"></i>
                  </a>
                </div>

                <!-- 更新資訊 -->
                <div *ngIf="rowData.itArticle?.updateUser" class="text-xs text-500 mt-1">
                  {{ 'HelpCenter.Setting.Results.LastUpdate' | translate }}：{{ rowData.itArticle.updateUser }} · {{ rowData.itArticle.updateDt | date:'yyyy/MM/dd' }}
                </div>
              </div>
            </ng-container>

              <!-- 檔案管理 -->
              <ng-container *ngSwitchCase="'files'">
                <div class="flex flex-column gap-2">
                  <!-- User Guide -->
                  <div class="flex align-items-center gap-2 cursor-pointer" (click)="openFileDialog(rowData, 'UserGuide')">
                    <i class="pi pi-book"></i>
                    <span class="text-sm">User Guide</span>
                    <p-tag
                      [severity]="rowData.userGuideExist ? 'success' : 'warning'"
                      [value]="(rowData.userGuideExist ? 'HelpCenter.Setting.Results.Uploaded' : 'HelpCenter.Setting.Results.NotUploaded') | translate"
                      [rounded]="true">
                    </p-tag>
                  </div>

                  <!-- User Files -->
                  <div class="flex align-items-center gap-2 cursor-pointer" (click)="openFileDialog(rowData, 'UserFile')">
                    <i class="pi pi-folder"></i>
                    <span class="text-sm">User Files</span>
                    <p-tag
                      [severity]="rowData.userFileExist ? 'success' : 'warning'"
                      [value]="(rowData.userFileExist ? 'HelpCenter.Setting.Results.Uploaded' : 'HelpCenter.Setting.Results.NotUploaded') | translate"
                      [rounded]="true">
                    </p-tag>
                  </div>
                </div>
              </ng-container>

              <!-- 預設 -->
              <ng-container *ngSwitchDefault>
                <div class="overflow-text">
                  {{ rowData[col.field] | replaceNullWith:'-' }}
                </div>
              </ng-container>

            </ng-container>
          </td>
        </ng-template>
      </laas-data-table>
    </ng-container>

    <!-- SINGLE view：卡片牆預覽 -->
    <ng-container *ngIf="viewMode === 'SINGLE'">
      <p-card>
        <!-- 頁面標題 -->
        <div class="flex align-items-center justify-content-between mb-4">
          <div>
            <h3 class="m-0 text-900">
              {{ singleGuideValue?.guideHeader || ('HelpCenter.Setting.Results.SingleHeader' | translate) }}
            </h3>
            <div class="text-500 text-sm mt-1">
              {{ singleGuideValue?.permissionCode }}
            </div>
          </div>
        </div>

        <div class="grid">

        <!-- User 文章卡片 -->
        <div class="col-12 md:col-6">
          <div class="guide-card" (click)="openArticleFromCard('USER')" pRipple>
            <!-- 標題區 -->
            <div class="guide-card-header guide-card-header-user">
              <div class="flex align-items-center gap-2">
                <i class="pi pi-file-edit text-lg"></i>
                <span class="font-semibold">{{ 'HelpCenter.Setting.Results.UserArticle' | translate }}</span>
              </div>
              <p-tag
                *ngIf="hasSingleUserContent()"
                [severity]="hasSingleUserPublishedContent() ? 'success' : 'warning'"
                [value]="(hasSingleUserPublishedContent() ? 'HelpCenter.Setting.Results.Published' : 'HelpCenter.Setting.Results.Unpublished') | translate"
                [rounded]="true">
              </p-tag>
            </div>

            <!-- 內容預覽區 -->
            <div class="guide-card-body">
              <div class="preview-content">
                {{ singleGuideValue?.userPreview || ('HelpCenter.Message.NoContent' | translate) }}
              </div>
            </div>

            <!-- 底部資訊 -->
            <div class="guide-card-footer">
              <i class="pi pi-user text-xs"></i>
              <span>{{ singleGuideValue?.updateUser || '-' }}</span>
              <span class="mx-2">·</span>
              <i class="pi pi-clock text-xs"></i>
              <span>{{ singleGuideValue?.updateDt | date:'yyyy/MM/dd HH:mm' }}</span>
            </div>
          </div>
        </div>

        <!-- IT 文章卡片 -->
        <div class="col-12 md:col-6">
          <div class="guide-card" (click)="openArticleFromCard('IT')" pRipple>
            <!-- 標題區 -->
            <div class="guide-card-header guide-card-header-it">
              <div class="flex align-items-center gap-2">
                <i class="pi pi-wrench text-lg"></i>
                <span class="font-semibold">{{ 'HelpCenter.Setting.Results.ITArticle' | translate }}</span>
              </div>
              <p-tag
                *ngIf="hasSingleITContent()"
                [severity]="hasSingleITPublishedContent() ? 'success' : 'warning'"
                [value]="(hasSingleITPublishedContent() ? 'HelpCenter.Setting.Results.Published' : 'HelpCenter.Setting.Results.Unpublished') | translate"
                [rounded]="true">
              </p-tag>
            </div>

            <!-- 內容預覽區 -->
            <div class="guide-card-body">
              <div class="preview-content">
                {{ singleGuideValue?.itPreview || ('HelpCenter.Message.NoContent' | translate) }}
              </div>
            </div>

            <!-- 底部資訊 -->
            <div class="guide-card-footer">
              <i class="pi pi-user text-xs"></i>
              <span>{{ singleGuideValue?.updateUser || '-' }}</span>
              <span class="mx-2">·</span>
              <i class="pi pi-clock text-xs"></i>
              <span>{{ singleGuideValue?.updateDt | date:'yyyy/MM/dd HH:mm' }}</span>
            </div>
          </div>
        </div>

          <!-- User Guide 檔案入口 -->
          <div class="col-12 md:col-6">
            <div class="guide-card guide-card-file"
                (click)="openFileDialog(singleGuideValue, 'UserGuide')"
                (keydown.enter)="openFileDialog(singleGuideValue, 'UserGuide')"
                tabindex="0"
                role="button"
                pRipple>
              <!-- 標題區 -->
              <div class="guide-card-header guide-card-header-user">
                <div class="flex align-items-center gap-2">
                  <i class="pi pi-book text-lg"></i>
                  <span class="font-semibold">{{ 'HelpCenter.Setting.Results.UserGuideTitle' | translate }}</span>
                </div>
                <p-tag
                  [severity]="singleUserGuideExist ? 'success' : 'warning'"
                  [value]="(singleUserGuideExist ? 'HelpCenter.Setting.Results.Uploaded' : 'HelpCenter.Setting.Results.NotUploaded') | translate"
                  [rounded]="true">
                </p-tag>
              </div>

              <!-- 說明區 -->
              <div class="guide-card-body text-center">
                <i class="pi pi-upload text-4xl text-400 mb-3"></i>
                <div class="text-600">
                  {{ 'HelpCenter.Setting.Results.UserGuideDesc' | translate }}
                </div>
              </div>
            </div>
          </div>

          <!-- User Files 入口 -->
          <div class="col-12 md:col-6">
            <div class="guide-card guide-card-file"
                (click)="openFileDialog(singleGuideValue, 'UserFile')"
                (keydown.enter)="openFileDialog(singleGuideValue, 'UserFile')"
                tabindex="0"
                role="button"
                pRipple>
              <!-- 標題區 -->
              <div class="guide-card-header guide-card-header-it">
                <div class="flex align-items-center gap-2">
                  <i class="pi pi-folder-open text-lg"></i>
                  <span class="font-semibold">{{ 'HelpCenter.Setting.Results.UserFileTitle' | translate }}</span>
                </div>
                <p-tag
                  [severity]="singleUserFileExist ? 'success' : 'warning'"
                  [value]="(singleUserFileExist ? 'HelpCenter.Setting.Results.Uploaded' : 'HelpCenter.Setting.Results.NotUploaded') | translate"
                  [rounded]="true">
                </p-tag>
              </div>

              <!-- 說明區 -->
              <div class="guide-card-body text-center">
                <i class="pi pi-upload text-4xl text-400 mb-3"></i>
                <div class="text-600">
                  {{ 'HelpCenter.Setting.Results.UserFileDesc' | translate }}
                </div>
              </div>
            </div>
          </div>

        </div>
      </p-card>
    </ng-container>
  </div>
</div>
